import { useMemo } from 'react';
import useDebouncedFetchSection from '../useDebouncedFetchSections';
import useFetchRecommendationPod from '../useFetchRecommendationPod';
import { isAutocompleteSection, isRecommendationsSection } from '../../typeGuards';
export default function useSectionsResults(query, cioClient, activeSections, advancedParameters) {
    // Fetch Autocomplete Results
    const activeAutocompleteSections = useMemo(() => activeSections?.filter((config) => isAutocompleteSection(config)), [activeSections]);
    const { sectionsData: autocompleteResults, request, totalNumResultsPerSection, } = useDebouncedFetchSection(query, cioClient, activeAutocompleteSections, advancedParameters);
    // Fetch Recommendations Results
    const activeRecommendationsSections = useMemo(() => activeSections?.filter((config) => isRecommendationsSection(config)), [activeSections]);
    const { fetchRecommendationResults, recommendationsResults, podsData } = useFetchRecommendationPod(cioClient, activeRecommendationsSections, advancedParameters?.fetchZeroStateOnFocus);
    return {
        recommendations: {
            results: recommendationsResults,
            fetchRecommendationResults,
            podsData,
        },
        autocomplete: {
            results: autocompleteResults,
            request,
            totalNumResultsPerSection,
        },
    };
}
